import { useMemo, useState } from 'react';
import { ALL_STUDIES_LABEL, FilterChipsProps } from './FilterChips.types';
import { buildChipLabels, filterItemsByChip } from './FilterChips.utils';
import { StChipButton, StChipScrollContainer } from './FilterChips.styles';
import { useRouter } from 'next/router';
const FilterChips = ({ items, onFilterChange }: FilterChipsProps): JSX.Element => {
  const [selectedChip, setSelectedChip] = useState(ALL_STUDIES_LABEL);
  const chipLabels = useMemo(() => buildChipLabels(items), [items]);
  const route = useRouter();
  const handleChipClick = (chip: string) => {
    const filtered = filterItemsByChip(items, chip);

    if (
      chip !== ALL_STUDIES_LABEL &&
      filtered.length === 1 &&
      filtered[0].fields.trialCTA?.value?.href
    ) {
      route.push(filtered[0].fields.trialCTA.value.href);
      return;
    }

    setSelectedChip(chip);

    onFilterChange(filtered);
  };

  return (
    <StChipScrollContainer role="tablist" aria-label="Filter studies by condition">
      {chipLabels.map((label) => {
        const isActive = selectedChip === label;
        return (
          <StChipButton
            key={label}
            type="button"
            role="tab"
            active={isActive}
            aria-pressed={isActive}
            aria-selected={isActive}
            onClick={() => handleChipClick(label)}
          >
            {label}
          </StChipButton>
        );
      })}
    </StChipScrollContainer>
  );
};

export default FilterChips;
